export enum IntercomAction {
  Show = 'show',
  Hide = 'hide',
  ShowNewMessage = 'showNewMessage',
  Boot = 'boot',
  Update = 'update',
  Shutdown = 'shutdown',
  onShow = 'onShow',
  onHide = 'onHide',
  onUnreadCountChange = 'onUnreadCountChange',
  startSurvey = 'startSurvey',
}

export enum Recipients {
  Support = 'support@recruitee.com',
  Sales = 'sales@recruitee.com',
  Finance = 'finance@recruitee.com',
  Analytics = 'analytics@recruitee.com',
}

export interface IntercomSurveyConfig {
  en: number;
  fr?: number;
  de?: number;
  nl?: number;
  sv?: number;
  fi?: number;
}

export interface IntercomEnvironment {
  intercom?: {
    surveys?: {
      pricing: IntercomSurveyConfig;
      requisitionsBetaPublishJob: IntercomSurveyConfig;
      requisitionsBetaRequestApproval: IntercomSurveyConfig;
      reportsGeneralSatisfaction: IntercomSurveyConfig;
      reportsTimeBased: IntercomSurveyConfig;
      reportsJobDashboard?: IntercomSurveyConfig;
    };
  };
}
